import {debug} from "btdt/config";

class LocationChooser {
    app = null
    el = null
    isOpen = false
    toggle = null
    isCorporate = null

    constructor(el, app) {
        this.el = el
        this.app = app
        this.isCorporate = el.dataset.corporate === '1'

        this.app.watchState('chosenLocation', location => {
            if (debug) console.log('updating location chooser with new chosen location', this.el)

            if (location) {
                // need to delete some keys that do not like to be converted to JSON
                delete location.marker
                delete location.el
            }

            this.updateWidget()
        })

        this.toggles = this.el.querySelectorAll('[data-widget-mobile-toggle]')

        if (this.toggles) {
            this.toggles.forEach(toggle => {
                toggle.addEventListener('click', () => {
                    this.isOpen = !this.isOpen
                    this.el.classList.toggle('open', this.isOpen)
                })
            })

            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        this.el.classList.add('collapsed')
                    } else {
                        this.el.classList.remove('collapsed')
                    }
                })
            },{threshold: 0})
            const footer = document.querySelector('footer.site-footer')
            if (footer) {
                observer.observe(footer)
            }
        }


        this.updateWidget()

    }

    updateWidget() {
        const setEl = this.el.querySelectorAll('[data-location-set]')
        const unsetEl = this.el.querySelectorAll('[data-location-unset]')
        const chosenLocation = this.app.getState('chosenLocation')
        const isLocationSelected = chosenLocation !== null

        if (isLocationSelected) {
            this.el.classList.remove('hidden')

            const nameEl = this.el.querySelector('[data-location-name]')
            const linkEl = this.el.querySelector('[data-location-link]')
            const btnEl = this.el.querySelector('[data-phone-btn]')
            const phoneEl = this.el.querySelector('[data-phone-link]')
            const textEl = this.el.querySelector('[data-text-link]')
            const textWrapperEl = this.el.querySelector('[data-text-wrapper]')

            if (nameEl) {
                nameEl.innerHTML = chosenLocation.location_name
                nameEl.setAttribute('href', chosenLocation.site)
            }

            if (linkEl) {
                linkEl.href = chosenLocation.site
            }

            const phone = this.isCorporate && chosenLocation.phone_corp ? chosenLocation.phone_corp : chosenLocation.phone;

            if (phoneEl) {
                if (phone) {
                    phoneEl.classList.remove('hidden')
                    phoneEl.innerHTML = phone
                    phoneEl.href = `tel:${phone}`
                } else {
                    phoneEl.classList.add('hidden')
                }
            }

            if (btnEl) {
                if (phone) {
                    btnEl.classList.remove('hidden')
                    btnEl.innerHTML = `Call: ${phone}`
                    btnEl.href = `tel:${phone}`
                } else {
                    btnEl.classList.add('hidden')
                }
            }

            if (textWrapperEl && textEl) {
                if (chosenLocation.phone_text) {
                    textWrapperEl.classList.remove('hidden')
                    if (chosenLocation.phone_text === chosenLocation.phone && chosenLocation.callrail) {
                        textEl.dataset.calltrkNoswap = 'true'
                    } else {
                        delete textEl.dataset.calltrkNoswap
                    }
                    textEl.innerHTML = chosenLocation.phone_text
                    textEl.href = `sms:${chosenLocation.phone_text}`
                } else {
                    textWrapperEl.classList.add('hidden')
                }
            }

        }

        if (setEl) {
            setEl.forEach(el => el.classList.toggle('hidden', !isLocationSelected))
        }

        if (unsetEl) {
            unsetEl.forEach(el => el.classList.toggle('hidden', isLocationSelected))
        }

    }
}

export default LocationChooser